import register from "preact-custom-element";
import { PlpProvider } from "@/providers/plp-provider";
import PlpProducts from "@/components/plp-products";
import PlpSidebar from "@/components/plp-sidebar";

const PlpResults = ({ collection, collectionUrl, priceSorting }) => {
  const displayNames = JSON.parse(
    document.querySelector("#display-names")?.innerHTML
  );

  let filtersConfiguration = JSON.parse(
    document.querySelector("#filters-configuration")?.innerHTML
  );

  if (Array.isArray(filtersConfiguration)) {
    const collection = filtersConfiguration[0]?.collection;
    let filters = [...filtersConfiguration[0]?.filters];
    if (filtersConfiguration[1]) {
      filters = [...filters, ...filtersConfiguration[1]?.filters];
    }
    filtersConfiguration = {
      collection,
      filters,
    };
  }

  const pickedFacets =
    filtersConfiguration && filtersConfiguration.filters
      ? [...filtersConfiguration.filters].sort((a, b) => {
          if (a.filter.order > b.filter.order) return 1;
          if (a.filter.order < b.filter.order) return -1;
          if (a.filter.name > b.filter.name) return 1;
          if (a.filter.name < b.filter.name) return -1;
        })
      : []; // Sort orders based on their order prop

  return (
    <PlpProvider
      collection={collection}
      pickedFacets={pickedFacets}
      displayNames={displayNames}
      priceSorting={priceSorting}
    >
      <div class="plp-results__grid grid grid-cols-3 lg:grid-cols-[258px_auto] xl:grid-cols-[316px_auto] md:gap-4 lg:gap-6 xl:gap-8 container pt-[23px] md:pt-[40px] xl:pt-[68px]">
        <h2 className="sr-only">Page Results</h2>
        <PlpSidebar />
        <PlpProducts
          collectionTitle={collection}
          collectionUrl={collectionUrl}
        />
      </div>
    </PlpProvider>
  );
};

register(PlpResults, "plp-results", [
  "collection",
  "picked-facets",
  "price-sorting",
]);
